import script from "./header-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./header-content.vue?vue&type=script&setup=true&lang=ts"

import "./header-content.vue?vue&type=style&index=0&id=79b7576d&lang=scss"

const __exports__ = script;

export default __exports__